import { Dialog } from "@headlessui/react";
import ErrorDisplay from "../../../components/error-display";
import FileUpload from "../../../components/file-upload";
import Trash from "../../../components/icons/trash";
import Loading from "../../../components/loading";
import SaveComplete from "../../../components/save-complete";
import { RulesetsState } from "../hooks/use-rulesets";

type ImportDataProps = {
  state: RulesetsState;
};

const ImportData = (props: ImportDataProps) => {
  const rulesetsState: RulesetsState = props.state;

  return (
    <div className="relative bg-white shadow-md rounded-md max-w-md mx-auto p-12 text-center">
      {rulesetsState.error && (
        <div className="-mt-12 -ml-12 -mr-12 mb-4">
          <ErrorDisplay
            message={rulesetsState.error}
            onClick={rulesetsState.clearErrorMessage}
          />
        </div>
      )}
      <Dialog.Title className="text-2xl text-primary-blue mb-2 font-semibold tracking-[0.07rem]">
        IMPORT RULESETS/RULES DATA
      </Dialog.Title>
      {!rulesetsState.importing && !rulesetsState.importComplete && (
        <div className="my-4">
          {rulesetsState.importFile === undefined && (
            <FileUpload
              multiple={false}
              filesAdded={(files) => {
                rulesetsState.setFile(files[0]);
              }}
              accept="application/json"
              fileDisplay="JSON"
            />
          )}
          {rulesetsState.importFile !== undefined && (
            <div className="w-full relative p-6 border bg-white shadow-md rounded-lg my-8">
              <div className="flex items-center gap-2">
                <div className="flex-grow">{rulesetsState.importFile.name}</div>
                <button
                  className="absolute -top-4 -right-4 h-12 w-12 bg-gray-200 rounded-full flex items-center justify-center"
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    rulesetsState.setFile(undefined);
                  }}
                >
                  <Trash className="h-6 w-6" />
                </button>
              </div>
            </div>
          )}
        </div>
      )}
      {rulesetsState.importing && !rulesetsState.importComplete && (
        <div className="my-4">
          <Loading message="IMPORTING" />
        </div>
      )}
      {rulesetsState.importComplete && (
        <div className="my-4">
          <SaveComplete message="IMPORT COMPLETE" />
        </div>
      )}
      <div className="flex justify-center gap-2 items-center mt-8">
        <button
          disabled={rulesetsState.importing}
          onClick={() => rulesetsState.cancelImport()}
          className="w-36 inline-flex tracking-[0.07rem] justify-center items-center px-6 py-3 text-primary-blue border border-primary-blue text-base font-semibold rounded-md shadow-sm bg-transparent hover:bg-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
        >
          CANCEL
        </button>
        <button
          disabled={
            rulesetsState.importing || rulesetsState.importFile === undefined
          }
          onClick={() => {
            rulesetsState.doImport();
          }}
          className={`${
            rulesetsState.importing || rulesetsState.importFile === undefined
              ? "opacity-40 cursor-not-allowed"
              : ""
          } w-36 inline-flex tracking-[0.07rem] justify-center items-center px-6 py-3 text-white border border-primary-blue text-base font-semibold rounded-md shadow-sm bg-primary-blue focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500`}
        >
          IMPORT
        </button>
      </div>
    </div>
  );
};

export default ImportData;
